import { root } from './verify';

export const verify = {
  ...root,
};
